import React from "react";
import "weather-icons/css/weather-icons.css";

const WeatherIcon = ({ code }) => {
  let icon;

  switch (code) {
    case 0:
      icon = "wi-day-sunny";
      break;
    case 1:
    case 2:
    case 3:
      icon = "wi-day-cloudy";
      break;
    case 45:
    case 48:
      icon = "wi-fog";
      break;
    case 51:
    case 53:
    case 55:
      icon = "wi-day-sprinkle";
      break;
    case 56:
    case 57:
      icon = "wi-day-sleet";
      break;
    case 61:
    case 63:
    case 65:
      icon = "wi-day-rain";
      break;
    case 66:
    case 67:
      icon = "wi-day-sleet-storm";
      break;
    case 71:
    case 73:
    case 75:
      icon = "wi-day-snow";
      break;
    case 77:
      icon = "wi-day-snow";
      break;
    case 80:
    case 81:
    case 82:
      icon = "wi-day-showers";
      break;
    case 85:
    case 86:
      icon = "wi-day-snow-wind";
      break;
    case 95:
      icon = "wi-day-storm-showers";
      break;
    case 96:
    case 99:
      icon = "wi-day-hail";
      break;
    default:
      icon = "wi-day-sunny";
      break;
  }

  return (
    <i
      className={`wi ${icon}`}
      style={{ marginTop: "1em", fontSize: "42px" }}
    />
  );
};

export default WeatherIcon;
